import { render, staticRenderFns } from "./pile-list.vue?vue&type=template&id=106d9966&"
import script from "./pile-list.vue?vue&type=script&lang=ts&"
export * from "./pile-list.vue?vue&type=script&lang=ts&"
import style0 from "./pile-list.vue?vue&type=style&index=0&id=106d9966&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports